module.exports = {
      id: "ic-25-index-v-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-25-index-v-usage",
      toString: function () {
        return this.url;
      }
    }